// src/components/PatientUpdateFormBody.js
import React, { useCallback } from "react";
import PatientInfoForm from "./PatientInfoForm";

function PatientUpdateFormBody({
  formValues,
  onInputChange,  // (id, value)
  options,
}) {

  const handleChange = useCallback(
    (id, value) => {
      onInputChange(id, value);
    },
    [onInputChange]
  );

  return (
    <PatientInfoForm
      values={formValues}
      onChange={handleChange}
      options={options}
      includeEdss={false} // モーダルでは EDSS 非表示
    />
  );
}

export default React.memo(PatientUpdateFormBody);
